var compImport = null;

function setCompImport(imp) {
    compImport = imp;
}

export { setCompImport, compImport as impo };
